import View from '../View';
import { breakpoint } from '../utils/dom';
import 'gsap/TweenMax';

require('waypoints/lib/noframework.waypoints.min');

/**
 * Footer
 */
class Footer extends View {
  /**
   * Footer constructor
   * @param node
   */
  constructor (node) {
    super(node);

    //Get all the clickable links with submenu in the Header
    this.subMenuLinks = Array.from(this.node.querySelectorAll('.js-submenu-toggle'));

    //If we have links, attach an event listener to all of them
    if (this.subMenuLinks) {
      this.subMenuLinks.forEach((link) => {
        link.addEventListener('click', this.toggleSubMenu);
      });
    }

    this.setPageStyles();

    events.on('resize', this.setPageStyles);
  }

  setPageStyles = () => {
    const pagePadding = this.node.offsetHeight + 'px';

    if (breakpoint('large-up')) {
      document.getElementById('root').style.paddingBottom = pagePadding;
    } else {
      document.getElementById('root').removeAttribute('style');
    }
  };

  //On small screens > toggle tool buttons open & closed§
  toggleSubMenu = (e) => {
    if (!e.currentTarget.classList.contains('open')) {
      this.openSubMenu(e);
    } else {
      this.closeSubMenu(e);
    }
  };

  /**
   * Toggle submenu open/closed after click (only on smaller screens)
   * @param e
   */
  openSubMenu = (e) => {
    //only on screens smaller than large
    if (breakpoint('large-down')) {
      this.subMenu = e.currentTarget.nextSibling.nextElementSibling;

      //animate open submenu
      TweenMax.set(this.subMenu, {
        height: 'auto',
      });
      TweenMax.from(this.subMenu, 0.5, {
        height: 0,
        ease: Power3.easeInOut,
      });

      e.currentTarget.classList.add('open');
      this.subMenu.classList.add('open');
    }
  };

  /**
   * Toggle submenu open/closed after click (only on smaller screens)
   * @param e
   */
  closeSubMenu = (e) => {
    //only on screens smaller than large
    if (breakpoint('large-down')) {
      this.subMenu = e.currentTarget.nextSibling.nextElementSibling;

      //animate open submenu
      TweenMax.set(this.subMenu, {
        height: 'auto',
      });
      TweenMax.to(this.subMenu, 0.5, {
        height: 0,
        ease: Power3.easeInOut,
      });

      e.currentTarget.classList.remove('open');
      this.subMenu.classList.remove('open');
    }
  };

}

export default Footer;



// WEBPACK FOOTER //
// frontend/js/components/Footer.js